import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),
    becomingAwareThroughOther: Yup.string()
        .when('becomingAwareThrough', {
            is: 'Sonstiges',
            then: Yup.string().required("Angabe ist erforderlich"),
        }),
    applicationLink: Yup.string(),
});

export const OtherInformationInformalSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings  } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group className="mb-3" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie bist du auf uns Aufmerksam geworden?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThroughInformal.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formApplicationLink">
                    <Form.Label>Dein Bewerbungsvideo/Website</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Link zu Bewerbungsvideo oder Website eingeben"
                        type="text"
                        name="applicationLink"
                        value={values.applicationLink}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.applicationLink && !errors.applicationLink}
                        isInvalid={touched.applicationLink && errors.applicationLink}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.applicationLink}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};